import React from 'react';
import { CheckIcon, ClockIcon } from 'lucide-react';
export type ModerationStatus = 'review' | 'live';
interface StatusBadgeProps {
  status: ModerationStatus;
  className?: string;
}

/**
 * Where a contribution stands. Shown only to the person who submitted it —
 * "in review" is information, never a judgement.
 */
export function StatusBadge({
  status,
  className = ''
}: StatusBadgeProps) {
  const isReview = status === 'review';
  const Icon = isReview ? ClockIcon : CheckIcon;
  return <span className={`inline-flex items-center gap-1.5 rounded-pill px-2.5 py-1 text-eyebrow-caption font-semibold uppercase ${isReview ? 'bg-canvas text-ink-muted' : 'bg-primary-soft text-primary-text'} ${className}`} data-id="element-550" data-mp="21vgob5ftt6f2">
      <Icon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-551" data-mp="1rxkdyfupqfi0" />
      {isReview ? 'In review' : 'Live'}
    </span>;
}